// extracted by mini-css-extract-plugin
module.exports = {"introduction":"Introduction_introduction_3lN00","button":"Introduction_button_p6pe9","buttonPrevious":"Introduction_buttonPrevious_1VVts","buttons":"Introduction_buttons_1hurF"};